module.exports = __webpack_public_path__ + "img/astral_5.7e244dfa.svg";